import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const setColorTheme = (isOSOnDarkMode, { force = false } = {}) => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  const shouldUseDarkMode = force
    ? isOSOnDarkMode
    : (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
      selectedColorScheme === 'dark';
  if (shouldUseDarkMode) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};
